import { useToasts } from '@/stores/toast';

const ICON = { success: '✓', error: '⚠', info: 'ℹ' } as const;

/**
 * The corner where short notices appear. Two live regions: errors are read
 * out at once, everything else waits for the screen reader to finish.
 */
export function Toaster() {
  const { toasts, dismiss } = useToasts();
  const errors = toasts.filter((t) => t.tone === 'error');
  const others = toasts.filter((t) => t.tone !== 'error');

  const render = (list: typeof toasts) =>
    list.map((t) => (
      <div key={t.id} className={`toast toast--${t.tone}`}>
        <span aria-hidden="true" className="toast__icon">
          {ICON[t.tone]}
        </span>
        <span className="toast__message">{t.message}</span>
        {t.action && (
          <button
            type="button"
            className="toast__action"
            onClick={() => {
              dismiss(t.id);
              t.action!.onClick();
            }}
          >
            {t.action.label}
          </button>
        )}
        <button type="button" className="toast__close" onClick={() => dismiss(t.id)} aria-label="Close notice">
          ×
        </button>
      </div>
    ));

  return (
    <div className="toaster">
      <div role="alert" aria-live="assertive">
        {render(errors)}
      </div>
      <div role="status" aria-live="polite">
        {render(others)}
      </div>
    </div>
  );
}
